import {
    InitialState,
    SailsTariffOverviewStorage,
} from 'Container/App/interface';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { SAILS_BNT_STORAGE } from '@vfde-sails/constants';
import NAMESPACE from 'Constant';

const getPreviousHardwareConfig = (): InitialState['previousHardwareConfig'] => {
    const storage = getSessionStorageItemJson<SailsTariffOverviewStorage>(SAILS_BNT_STORAGE);

    return storage?.[NAMESPACE]?.previousHardware || null;
};

export default getPreviousHardwareConfig;
